// extracted by mini-css-extract-plugin
export default {"bold":"style--bold--dbdf67","borderRight":"style--borderRight--3302db","textAlignRight":"style--textAlignRight--b9edec"};